import { Form } from "antd";
import dayjs, { Dayjs } from "config/dayjs";
import { createContext, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { DATA_PAGE_OVERVIEW } from "./data-page-overview";
import { DATA_PAGE_OVERVIEW_PROPERTY } from "./data-page-overview-property";
import { IFindDate, IOverviewContext } from "./interface";

const Context = createContext<IOverviewContext>({} as IOverviewContext);

const OverviewProviderApp: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [form] = Form.useForm();
  const [menusView, setMenusView] = useState<JSX.Element[]>([]);
  const [menus, setMenus] = useState<string[]>([]);
  const [property, setProperty] = useState();
  const { propertyId } = useParams();

  const setInitialValues = () => {
    const now = dayjs();
    const initialData = {
      ...getStatisticData(now),
      ...getWorkPlanData(now),
      ...getSurveyData(now),
      ...getNewsData(now),
      ...getHomeCareData(now),
      ...getParcelData(now),
      ...getComplaintData(now),
      ...getFacilityData(now),
      ...getVehicleData(now),
      ...getSellAndRentData(now),
      ...getVotingData(now),
      ...getActivitiesData(now),
      ...getWorkSpaceData(now),
      administratorsDate: now,
      residentsDate: now,
      backOfficeDate: now,
    };

    form.setFieldsValue(initialData);
  };

  const onClearMenu = () => {
    form.setFieldValue("menu", undefined);
    setMenusView([]);
  };

  const onSearchMenu = () => {
    const values = form.getFieldValue("menu");

    if (values) {
      const filter: JSX.Element[] =
        values?.map((e: string) => {
          if (propertyId) return DATA_PAGE_OVERVIEW_PROPERTY[e];
          return DATA_PAGE_OVERVIEW[e];
        }) || [];
      setMenusView(filter);
      setMenus(values);
    }
  };

  const findDate = (date: any, type?: "month" | "year"): IFindDate => {
    const startDate = dayjs(date)
      .startOf(type || "month")
      .toISOString();
    const endDate = dayjs(date)
      .endOf(type || "month")
      .toISOString();
    return { startDate, endDate };
  };

  const onSearchCentral = () => {
    const propertyForm = form.getFieldValue("property");
    const menusForm = form.getFieldValue("menu");

    setProperty(propertyForm);

    const filter: JSX.Element[] =
      menusForm?.map((e: string) => {
        if (propertyId) return DATA_PAGE_OVERVIEW_PROPERTY[e];
        return DATA_PAGE_OVERVIEW[e];
      }) || [];
    setMenusView(filter);
    setMenus(menusForm);
  };

  const onClearCentral = () => {
    form.setFieldValue("menu", undefined);
    form.setFieldValue("property", undefined);
    form.submit();
    setMenusView([]);
    setProperty(undefined);
  };

  return (
    <Context.Provider
      value={{
        form,
        onClearMenu,
        onSearchMenu,
        onClearCentral,
        onSearchCentral,
        property,
        menusView,
        setMenusView,
        menus,
        findDate,
        setInitialValues,
      }}
    >
      {children}
    </Context.Provider>
  );
};

const getStatisticData = (now: Dayjs) => ({
  groupDate: now,
  applicationDate: now,
  listMenusDate: now,
  teamUpAppDate: now,
  smoothUpAppDate: now,
  summaryDate: now,
  backOfficeDate: now,
  backOfficePropertyDate: now,
  teamUpAppPropertyDate: now,
  smoothUpAppPropertyDate: now,
  summaryPropertyDate: now,
  listMenusPropertyDate: now,
});

const getWorkPlanData = (now: Dayjs) => ({
  workRemainingDate: now,
  workloadDate: now,
});

const getSurveyData = (now: Dayjs) => ({
  surveyDate: now,
});

const getNewsData = (now: Dayjs) => ({
  listNewsDate: now,
  newsDate: now,
});

const getHomeCareData = (now: Dayjs) => ({
  repairDate: now,
  unitRepairDate: now,
  repairTypesDate: now,
  budgetsDate: now,
  dailyWorkloadDate: now,
  dailySlaDate:now,
  
});

const getParcelData = (now: Dayjs) => ({
  parcelsStillDate: now,
  typeParcelDate: now,
  allStatusDate: now,
  unitParcelDate: now,
  dailyParcelDate: now,
  analyzeTrendsParcelsDate: now,
});

const getComplaintData = (now: Dayjs) => ({
  numberComplaintsDate: now,
  volumeComplaintsDate: now,
  statusComplaintsDate: now,
});

const getFacilityData = (now: Dayjs) => ({
  mostUsedFacilitiesDate: now,
  facilityTypeDate: now,
  facilityTopDate: now,
  facilitiesUsedEachMonthDate: now,
});

const getVehicleData = (now: Dayjs) => ({
  mostUsedVehicleDate: now,
  vehicleTopDate: now,
});

const getSellAndRentData = (now: Dayjs) => ({
  saleAndRentDate: now,
});

const getVotingData = (now: Dayjs) => ({
  votingDate: now,
});

const getActivitiesData = (now: Dayjs) => ({
  listActivitiesDate: now,
  activitiesDate: now,
});

const getWorkSpaceData = (now: Dayjs) => ({
  workSpaceDate: now,
  workSpaceTopDate: now,
});

export const useOverview = () => useContext(Context);
export default OverviewProviderApp;
